export const Environment = {
    sasToken:
    '?sv=2026-02-06&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2031-09-04T20:01:36Z&st=2026-05-23T11:46:36Z&spr=https,http&sig=ODmzYsRhIx2JZRn5QgbHwxLvOz4nbKT83Fc9cboz9Wg%3D',
  accountName: 'prodsewa',
  containerName: 'sewa',
  baseUrl: 'https://api.sews.ai/whatsapp'
}